// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__2Kifp","actionsContainer":"styles_actionsContainer__23LFD"};